import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { LoginDataService } from './services/dhukan/login-data.service';
import { BnNgIdleService } from 'bn-ng-idle';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit,AfterViewChecked  {
  
 
  title = 'BISTRO';

  userBO: any = {};
  userrolerightsColl: any = [];  
  userView: any = {};


  islogin:boolean=false;

  constructor(private appService: LoginDataService, private bnIdle: BnNgIdleService) {
    // this.bnIdle.startWatching(300).subscribe((res) => {
    //   if (res) {
    //     localStorage.removeItem("bstoken");
        
    //     this.appService.fnCheckLogin();
    //   }
    // })

    this.appService.fnCheckLogin();

    this.fnServiceChanges()
  }


  fnServiceChanges() {
    this.userrolerightsColl = this.appService.userrolerightsColl;
    this.appService.serviceloginChange.subscribe((value) => {
      this.userView = value
      if (this.userView.userBO) {
        this.userBO = this.userView.userBO    
        if (this.userBO.userid > 0) {
          this.islogin = false
          this.appService.islogin= false
        }
      }
    });
  }

  ngOnInit() { 
    
   
  }

  ngAfterViewChecked(): void {

    setTimeout(() =>  this.islogin=this.appService.islogin );
     
  }

}
